module.exports = __webpack_public_path__ + "static/media/fi.395ac970.svg";